module.exports = __webpack_public_path__ + "img/nuestra_historia_nuevo.a00552a9.webp";